<style xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    .bottom_btn_custom{
        display: inline;
        padding: 10px;
        padding-right: 0px;

    }
    .el-input__icon {
        height: 100%;
        width: 25px;
        text-align: center;
        -webkit-transition: all .3s;
        transition: all .3s;
        line-height: 28px;
    }
    .el-input__inner {
        -webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 28px;
        line-height: 28px;
        outline: 0;
        -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        width: 100%;
    }
    .title_body {
        padding:0px;
    }
</style>
<template>
    <div>
        <CCard>
            <CCardHeader>
                <CIcon name="cil-justify-center"/> <strong> 청구 내역 </strong>
                <small></small>
            </CCardHeader>
            <CCardBody class="title_body">
                <CNavbar light color="light">
                    <CForm inline>
                       <!-- <div role="group" class="form-group form-row" style="margin-right: 10px;">
                            <div class="col-sm-9 input-group-sm">
                                <el-date-picker
                                        size="sm"
                                        v-model="monthVal"
                                        type="month"
                                        placeholder="월을 선택하세요"
                                        @click="searchList"
                                >
                                </el-date-picker>
                            </div>
                        </div>-->
                        <div role="group" class="form-group form-row" style="margin-right: 10px;">
                            <div class="col-sm-9 input-group-sm">
                                <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="startMonthVal" min="2000-01-02" max="2999-12-31" >
                            </div>
                        </div>
                        <div role="group" class="form-group form-row" style="margin-right: 10px;">
                            <div class="col-sm-9 input-group-sm">
                                <input id="uid-dq9zl88hwf8" type="date"  class="form-control" v-model="endMonthVal" min="2000-01-02" max="2999-12-31" >
                            </div>
                        </div>
                        <div role="group" class="form-group form-row">
                            <div class="col-sm-9 input-group-sm">
                                <CInput
                                        class="mr-sm-2"
                                        placeholder="이름 또는 진료번호"
                                        size="sm"
                                        v-model="searchVal"
                                        @keyup.enter="searchList"
                                />
                            </div>
                        </div>
                        <CButton color="outline-success" size="sm" class="my-2 my-sm-0" type="button" @click="searchList">검색</CButton>
                    </CForm>
                </CNavbar>
            </CCardBody>
        </CCard>
        <CRow>
            <div class="col-sm-12" style="margin-bottom: 10px;">
                <div class="col-sm-0.5">
                    <li class="bottom_btn_custom">
                        <div class="d-inline-block dropdown">
                            <select id="uid-utosbj1koo"  v-model="selectOption"  @change="selectPerPage" class="form-control">
                                <option value="10" selected>10개씩보기</option>
                                <option value="20">20개씩보기</option>
                                <option value="I50">50개씩보기</option>
                            </select>
                        </div>
                    </li>
                    <li class="bottom_btn_custom" style="float: right;">
                        <CButton label=""
                                 type="button"
                                 style="text-align: right"
                                 class="btn btn-info " @click="goExcelDownload">엑셀 다운로드
                        </CButton>
                    </li>
                </div>
            </div>

        </CRow>
        <CRow>
            <CCol sm="12">
                <div bordered="true" small="true">
                    <div class="position-relative table-responsive">
                        <b-table
                                id = "list-table"
                                :items="newItems"
                                :fields="fields"
                                :per-page="perPage"
                                :current-page="currentPage"
                                striped hover
                        >
                            <template v-slot:cell(id)="data">
                                <b  class="text-right">{{data.item.id }}</b>
                            </template>
                            <template v-slot:cell(amount)="data">
                                <div  class="text-right">{{data.item.amount }}</div>
                            </template>
                        </b-table>

                    </div>
                    <!--<div style="float:right;">총합계  요청건수: {{chargeCnt}} / 청구금액: {{totalChargeAmount | comma}} 원 </div>-->
                    <div id="tje5Special">
                        <ul class="cf">
                            <li style="width: 220px;">
                                <p>청구금액: {{totalChargeAmount | comma}} 원</p>
                            </li>
                            <li>
                                <p>요청건수: {{chargeCnt}} 건</p>
                            </li>
                        </ul>
                    </div>
                    <b-pagination
                            :link-gen="linkGen"
                            :number-of-pages="10"
                            use-router
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="list-table"
                    />
                </div>
            </CCol>
        </CRow>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
</style>
<script>
    import axios from "axios"
    import Vue from 'vue';
    import DatePicker from 'element-ui';
    import 'element-ui/lib/theme-chalk/index.css';
    import lang from 'element-ui/lib/locale/lang/ko'
    import locale from 'element-ui/lib/locale'
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    // configure language
    locale.use(lang)

    Vue.use(DatePicker);

    export default {
        name: 'app',
        components: {},
        data () {
            return {
                items: [],
                selectOption :10,
                searchVal: null,
                /*monthVal: '',*/
                newItems: [],
                perPage: 10,
                currentPage: 1,
                chargeCnt:0,
                startMonthVal:  this.$moment().add(-30,'d') .format('YYYY-MM-DD'),
                endMonthVal: this.$moment().format('YYYY-MM-DD'),
                totalChargeAmount:0,
                fields: [
                    {
                        key: 'id',
                        label: 'No',
                        class:'width_set_no',
                        sortable: true
                    },
                    {
                        key: 'insertTime',
                        label: '청구일',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'custName',
                        label: '이름',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'registNo',
                        label: '진료번호',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'item',
                        label: '청구항목',
                        class:'width_set_nine',
                        sortable: true
                    },
                    {
                        key: 'amount',
                        class:'textRight',
                        label: '청구액',
                        sortable: true
                    }
                ]
            }
        },
        computed: {
            rows() {
                return this.items.length;
            }
        },
        filters:{
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
        },
        mounted () {
            this.searchList();
        },
        methods: {
            searchList(value){
                const qs = require('qs');
                const formData = qs.stringify({'startMonthVal': this.startMonthVal, 'endMonthVal':this.endMonthVal, 'searchVal': this.searchVal})

                axios.post('silver/charge/getChargeList', formData)
                    .then(res => {
                        this.newItems=[]
                        console.log("===================");
                        console.log(res.data);
                        console.log("===================");
                        this.items = res.data;
                        for(var i = 0; i < this.items.length; i++){
                            const obj = new Object();
                            obj.id = this.items[i].id;
                            obj.insertTime = this.$moment(this.items[i].insertTime).format('YYYY-MM-DD');
                            obj.custName = this.items[i].custName;
                            obj.registNo = this.items[i].registNo;
                            obj.item = this.items[i].item;
                            obj.amount = this.comma(this.items[i].amount)+"원";

                            this.newItems.push(obj);
                        }
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
                axios.post('silver/charge/getChargeListCnt', formData)
                    .then(res => {
                        this.chargeCnt = res.data.chargeCnt;
                        this.totalChargeAmount = res.data.totalChargeAmount;
                    })
                    .catch(function(error) {
                        console.log(error);
                    });
            }
            , selectPerPage () {
                this.perPage =  this.selectOption;
            },
            linkGen(pageNum) {
                return pageNum === 1 ? '?' : `?page=${pageNum}`
            },
            comma(val){
                return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            goExcelDownload() {
                const qs = require('querystring');
                const formData = qs.stringify({
                    'startMonthVal': this.startMonthVal,
                    'endMonthVal':this.endMonthVal,
                    'searchVal': this.searchVal
                });

                axios.post('silver/charge/getChargeListExcel', formData, {
                    responseType: "blob",
                }).then(res => {
                    try {
                        let blob = new Blob([res.data], { type: res.headers['content-type'] });
                        //let fileName = this.getFileName(res.headers['content-disposition']);


                        //파일명 인코딩 문제로 직업 삽입
                        let fileName = "청구내역리스트.xlsx";
                        // fileName = decodeURI(fileName); // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)

                        if (window.navigator.msSaveOrOpenBlob) { // IE 10+
                            window.navigator.msSaveOrOpenBlob(blob, fileName)
                        } else { // not IE
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.target = '_self';
                            if (fileName) link.download = fileName;
                            link.click();
                            link.remove();
                        }
                    } catch (e) {
                        console.error(e)
                    }
                }).catch(error => {
                    console.log(error);
                });
            } , getFileName (contentDisposition) {
                let fileName = contentDisposition
                    .split(';')
                    .filter((ele) => {
                        return ele.toLowerCase().indexOf('filename') > -1
                    })
                    .map((ele) => {
                        return ele
                            .replace(/"/g, '')
                            .split('=')[1]
                    });
                return fileName[0] ? fileName[0] : null
            }
        }

    }
</script>
